import styled, { css } from 'vue-styled-components';

import {
    FLEX_CENTER_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';
import { GRAY } from '@/styles/common.styled';

export const Content = styled(FLEX_CENTER_DIV)`
    width: 100%;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 13px;

    svg {
        width: 14px;
        height: 14px;
    }

    .selected-box-wrapper {
        position: relative;
        /* flex: 1; */

        .selected-box {
            height: 36px !important;
            padding-left: 10px;
            &:hover {
                background-color: #f7f7f7;
            }
        }

        .searchbar-wrapper {
            margin-top: 5px;
            padding-bottom: 2px;
            border: 1px solid ${GRAY(30)};
            border-radius: 2px;
        }
    }

    .selected-option-item {
        background-color: #f7f7f7;
    }

    .field-dropdown,
    .operator-dropdown,
    .operator-wrapper {
        max-width: 49%;
        flex: 1;
        position: relative;

        .dropdown-text {
            padding-left: 10px;
        }
    }

    .multi-value-input {
        width: calc(100% - 42px);
    }

    .value-dropdown {
        position: relative;
        width: calc(100% - 42px);

        .dropdown-text {
            padding-left: 10px;
        }

        .dropdown-menu-wrapper {
            max-height: 300px;
        }
    }

    .value-checkbox-dropdown-wrapper {
        position: relative;
        width: calc(100% - 42px);

        svg {
            width: 14px;
            height: 14px;
        }

        .selected-box {
            align-items: start;
            height: unset;
            padding: 2px 7px;

            .arrow-icon {
                height: 30px;
            }

            h1 {
                flex: 1;
                min-height: 30px;
                max-height: 82px;
                line-height: 30px;
                overflow-y: auto;
                /* overflow-x: auto; */

                & > div {
                    flex-wrap: wrap;
                }

                &::-webkit-scrollbar {
                    -webkit-appearance: none;
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: ${GRAY(25)};
                    padding: 4px 8px;
                }
            }
        }

        .value-checkbox-dropdown {
            position: absolute;
            width: 320px;
            // set checkbox dropdown wrapepr
            max-height: 480px;
            overflow-y: auto;
            margin-top: 5px;
            z-index: 10;
            border: 1px solid ${GRAY(30)};
            border-radius: 2px;
            background: white;

            .header {
                display: none;
            }

            .search-bar {
                width: 100%;
                height: 32px;
                border-radius: 2px;
            }

            #dimensionGroup {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }

        .filter-option-item {
            height: 40px;
            padding: 10px 15px;
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        .filter-option-item:hover {
            background-color: #f7f7f7;
        }
    }

    .ant-dropdown-menu {
        border: 1px solid ${GRAY(30)};
    }

    .adriel-field-wrapper {
        width: calc(100% - 42px);
        & > input {
            width: 100%;
            cursor: text;
        }
    }

    .disabled,
    .disabled > input {
        background-color: unset !important;
        color: ${GRAY(30)};
        fill: ${GRAY(30)};
        cursor: unset;
    }
`;

export const ItemWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 100%;
`;

export const ItemText = styled.div`
    flex: 1;
`;

export const ApplyRemoveBtnCss = css`
    width: 32px;
    height: 32px;
    border-radius: 3px;
`;

export const SelectedItemWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    gap: 3px;
`;

export const SelectedItem = styled(FLEX_VERTICAL_CENTER_DIV, {
    showAllContent: Boolean,
})`
    max-width: ${({ showAllContent }) => (showAllContent ? 'unset' : '150px')};
    height: 28px;
    justify-content: space-between;
    gap: 3px;
    padding-left: 10px;
    padding-right: 6px;
    border-radius: 2px;
    background: ${GRAY(10)};
`;

export const SelectedText = styled.div`
    flex: 1;
`;

export const SpaceHolder = styled.div`
    height: 15px;
`;

